import * as React from 'react';

import ActionButton from 'components/action-button';
import { useAuthContext } from 'state/auth';
import { t } from 'state/intl/translations';
import { region } from 'utils/environment';
import { Region } from 'utils/environment/types';
import { routes } from 'utils/routing';

import {
  ButtonContainer,
  HeaderAndLogoContainer,
  HeaderContainer,
  HistorySignUpContainer,
  NormalText,
  StyledLink,
  StyledRewardsLogo,
} from './history-sign-up.styled';

export const HistorySignUp: React.FC = () => {
  const { openSignInModal } = useAuthContext();
  const isCanada = region === Region.CA;

  return (
    <HistorySignUpContainer testID="history-sign-up-card">
      <HeaderAndLogoContainer>
        <StyledRewardsLogo />
        <HeaderContainer>
          <NormalText>{t('loyaltyHistorySignUp')}</NormalText>
        </HeaderContainer>
      </HeaderAndLogoContainer>
      <ButtonContainer>
        <ActionButton fullWidth onPress={() => openSignInModal()}>
          {t('signInUp')}
        </ActionButton>
        <StyledLink to={isCanada ? routes.bkRewards : routes.royalPerks}>
          {t('learnMore')}
        </StyledLink>
      </ButtonContainer>
    </HistorySignUpContainer>
  );
};
